var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white-background"},[_c('QMyClientsSubmenu'),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('QApplicationsAuditTable',{attrs:{"title":"Submitted Applications"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }